import { render, staticRenderFns } from "./DatasetParameter.vue?vue&type=template&id=65b157c0&scoped=true&"
import script from "./DatasetParameter.vue?vue&type=script&lang=js&"
export * from "./DatasetParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b157c0",
  null
  
)

export default component.exports